import React from 'react';

const Influencers = () => {
    return (
      <div>
        <p>This is Influencers</p>
      </div>
    );
};

export default Influencers;